
import React from 'react';

const PricePayment = ({ order }) => {
  const paymentMethod = order.paymentMethod?.toLowerCase().includes('cod')
    ? 'COD'
    : 'PREPAID';

  return (
    <div className="flex items-center justify-between mb-6">
      <div
        className="inline-flex items-center px-6 py-3 bg-[#DBAE6E] text-black text-2xl font-bold rounded-lg shadow-md shadow-[#DBAE6E]/30 hover:bg-[#e6c083] transition-colors cursor-default"
        title="Total Price"
      >
        Rs {order.totalPrice || '0'}
      </div>
      <span
        className={`inline-flex items-center px-4 py-2 rounded-full text-sm font-bold ${
          paymentMethod === 'COD'
            ? 'bg-green-500/20 text-green-500 border border-green-500/50'
            : 'bg-red-500/20 text-red-500 border border-red-500/50'
        }`}
      >
        {paymentMethod}
      </span>
    </div>
  );
};

export default PricePayment;
